module.exports = __webpack_public_path__ + "img/banner-img-md.d3e916ae.png";